import { render, staticRenderFns } from "./relationorderlist.vue?vue&type=template&id=9a8f8d7c"
import script from "./relationorderlist.vue?vue&type=script&lang=js"
export * from "./relationorderlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports